import { Route as ReactRouterRoute, Redirect, RouteProps } from "react-router-dom";
import GlobalLoading from "components/LoadingAnimations/GlobalLoading";
import useAuthContext from "store/Auth/useAuthContext";
import { EAuthState } from "types/interfaces/IAuth";
import { ROUTES } from "routes/constants";

export interface IRoute extends Omit<RouteProps, "component" | "render"> {
  component?: React.ElementType;
  private?: boolean;
}

const Route: React.FC<IRoute> = ({ component: Component, private: isPrivate, children, ...props }) => {
  const { userInfo, authState } = useAuthContext();

  const render = () => {
    if (!Component) {
      return null;
    }

    if (!isPrivate || userInfo) {
      // optional
      return <Component />;
    }

    switch (authState) {
      case EAuthState.AUTHENTICATED:
        return <Component />;
      case EAuthState.UNAUTHENTICATED:
        return (
          <Redirect
            to={{
              pathname: ROUTES.login
            }}
          />
        );
      case EAuthState.PENDING:
      default:
        return <GlobalLoading />;
    }
  };

  return <ReactRouterRoute {...props}>{children ?? render()}</ReactRouterRoute>;
};

export default Route;
